import React from "react";
import { withRouter } from "react-router-dom";
import { Modal } from "@culturehq/components";

import ChqModal from "components/common/ChqModal";
import AttendeeList from "./attendees/AttendeeList";

const AttendeesModal = ({ children, event, location, onEventUpdate, onRefreshInvitations }) => (
  <ChqModal
    className="attendees-mdl"
    entrance="zoomIn"
    startOpen={location.hash === "#attendees"}
    trigger={children}
  >
    <Modal.Body>
      <AttendeeList
        event={event}
        onEventUpdate={onEventUpdate}
        onRefreshInvitations={onRefreshInvitations}
      />
    </Modal.Body>
  </ChqModal>
);

export default withRouter(AttendeesModal);
